import styled from "styled-components";
import { TextColorNames } from "@smartsuite/types";

export const StyledLabel = styled.div`
  margin: 5px 0 26px 15px;
  color: ${TextColorNames.primary};
  font-size: 12px;
  line-height: 18px;
  cursor: pointer;
  user-select: none;

  &:hover {
    color: ${TextColorNames.tertiary};
  }

  .icon {
    margin-left: 8px;
    vertical-align: text-top;
  }
`;

export const StyledOptionalFieldWrap = styled.div`
  margin: 0 0 8px;
`;
